import React from 'react';


function StyledButtonInline() {
  return (
    <button
      style={{
        backgroundColor: 'teal',
        padding: '10px 20px',
        fontSize: '16px',
        color: 'white',
        border: 'none',
        borderRadius: '4px'
      }}
    >
      Inline Styled Button
    </button>
  );
}


export default StyledButtonInline;